import React, { Children } from 'react';

const FormFooter = ({ children }) => {
  return <div className='FormFooter'>{children}</div>;
};

export default FormFooter;
